/**
 * Get product image URL with fallback to placeholder
 * @param {string|undefined|null} imageUrl - The product image URL
 * @returns {string} - The image URL or placeholder
 */
export const getProductImage = (imageUrl) => {
  if (imageUrl && imageUrl.trim() !== '') {
    return imageUrl;
  }
  return getPlaceholderImage();
};

/**
 * Get placeholder image URL
 * Uses an SVG data URI as a lightweight, always-available placeholder
 * @returns {string} - Placeholder image data URI
 */
export const getPlaceholderImage = () => {
  // SVG placeholder - lightweight, always available, no network request needed
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3Crect fill='%23f3f4f6' width='400' height='400'/%3E%3Ctext fill='%239ca3af' font-family='system-ui,-apple-system,sans-serif' font-size='18' font-weight='500' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo Image%3C/text%3E%3C/svg%3E";
};

/**
 * Handle image error by setting placeholder
 * @param {Event} event - The error event
 */
export const handleImageError = (event) => {
  // Prevent infinite loop if placeholder also fails
  if (event.target.src !== getPlaceholderImage()) {
    event.target.src = getPlaceholderImage();
  }
};

/**
 * Get product main image with fallback
 * @param {Object} product - Product object
 * @returns {string} - Image URL
 */
export const getProductMainImage = (product) => {
  if (product?.images?.main) {
    return product.images.main;
  }
  if (product?.image) {
    return product.image;
  }
  return getPlaceholderImage();
};

/**
 * Get product gallery images with fallback
 * @param {Object} product - Product object
 * @returns {Array<string>} - Array of image URLs
 */
export const getProductGalleryImages = (product) => {
  const images = [];
  
  // Add main image first
  if (product?.images?.main) {
    images.push(product.images.main);
  } else if (product?.image) {
    images.push(product.image);
  }
  
  // Add gallery images
  if (product?.images?.gallery && Array.isArray(product.images.gallery)) {
    product.images.gallery.forEach((img) => {
      if (img && img.trim() !== '' && !images.includes(img)) {
        images.push(img);
      }
    });
  }
  
  // If no images, return placeholder
  if (images.length === 0) {
    return [getPlaceholderImage()];
  }
  
  return images;
};
